import GameParameterInterface from '@/models/game/parameters/interface'

export interface TurningLotteryGameLotteryParameter {
  prize: TurningLotteryGamePrize
  generalValue: number
}

interface TurningLotteryGamePrize {
  prizeImage: string,
}

export default class TurningLotteryParameter implements GameParameterInterface {
  constructor(private parameter: TurningLotteryGameLotteryParameter) { }

  createSetOption(): TurningLotteryGameLotteryParameter {

    return {
      prize: this.parameter.prize,
      generalValue: this.parameter.generalValue,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
